module.exports = __webpack_public_path__ + "img/3_Dicks_Screen_3_R.538db8ec.jpg";